import ApiService from "./api.base.service";

class LiDARExportService extends ApiService {
  constructor() {
    super({
      baseURL: `${process.env.VUE_APP_LIDAR_API_HOST}`,
    });
  }
  submit(tileIdList, orgtype) {
    return this.instance.post("/submit", {
      LutProductTileId: tileIdList,
      OrgType: orgtype,
    });
  }
  download(token) {
    const url = new URL(
      `${process.env.VUE_APP_LIDAR_API_HOST}download/download-${token}.zip`,
      window.location.protocol + "//" + window.location.host,
    );
    const a = document.createElement("a");
    a.href = url.href;
    a.download = `lidar-${token}.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return url.href;
  }
}

export default new LiDARExportService();
